import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { CookieConsentRequestContainer, CookieConsentRequestContent, } from '../styles/LocationFilter.styles';
import { trackClicks } from '../MAStracking';
import { useServicesContext } from '../../../context';
import { Text, Headline, TextButton, Icon, } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT, } from '@oneaudi/unified-web-common';
import { useDesktopOrMobileView } from '../../../hooks';
import { dynamicStylingHelper, DynamicThemeProviderWrapper } from '../../utils';
export const CookieConsentRequest = ({ mapConsentButtonText, openConsentOverlay, setIsTwoClickOverlayOpened, showIcon = true, isMas, }) => {
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const requestHeadline = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentRequestDealerList.Headline`,
        defaultMessage: 'Please give us your consent',
    });
    const requestContent = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentRequestDealerList.Content`,
        defaultMessage: 'Please note that some content may not be available for use without consent. We therefore recommend that you give the necessary consent.',
    });
    const isMobile = useDesktopOrMobileView('767px') === 'mobile';
    return (React.createElement(CookieConsentRequestContainer, { isMas: isMas },
        React.createElement(DynamicThemeProviderWrapper, null, showIcon && React.createElement(StyledIcon, { name: "info-circle", size: "s", isMas: isMas })),
        React.createElement(CookieConsentRequestContent, { isMas: isMas },
            React.createElement(StyledHeadline, { tag: isMas ? 'h4' : 'h2', variant: {
                    order: isMas ? '4' : dynamicStylingHelper('4', '3'),
                    type: 'headline',
                    weight: 'normal',
                }, isMas: isMas }, requestHeadline),
            React.createElement(StyledText, { tag: "p", variant: {
                    order: '1',
                    style: 'normal',
                    type: 'copy',
                }, isMas: isMas }, requestContent),
            React.createElement(TextButton, { variant: "primary", size: "sm", onClick: () => {
                    openConsentOverlay();
                    setIsTwoClickOverlayOpened(true);
                    if (isMas) {
                        trackClicks(trackingService, 'mandatory area search - consent layer open click', mapConsentButtonText, 'button', '', '');
                    }
                }, isFullWidth: isMobile }, mapConsentButtonText))));
};
export default CookieConsentRequest;
const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  color: ${(props) => !props.isMas &&
    dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT)};
`;
const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  color: ${dynamicStylingHelper('unset', SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT)};
`;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  color: ${dynamicStylingHelper('unset', SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT)};
`;
